import React, { Component } from 'react';
import { FormattedDate, FormattedMessage, FormattedTime, injectIntl } from 'react-intl';
import Icon from "../common/icon/icon.component.jsx";
import UserNameLabel from "../common/user/label.component.jsx";
import InternalNotesModal from "../project/internalnotesmodal.component.jsx";

class InternalNotes extends Component {

    constructor(props) {
        super(props)
        this.state = {
            modal: '',
            internalNotes: this.sortInternalNotes(this.props.internalNotes || []),
            showAll: false,
        }
        this.toggleShowAll = this.toggleShowAll.bind(this)
        this.handleCloseAndRefresh = this.handleCloseAndRefresh.bind(this)
        this.handleCloseModal = this.handleCloseModal.bind(this)
        this.sortInternalNotes = this.sortInternalNotes.bind(this)
    }

    handleCloseAndRefresh() {
        this.setState({
            modal: ''
        })
        this.handleRefreshEvent()
    }

    componentDidUpdate(prevProps) {
        const lengthHasChanged = prevProps.internalNotes.length !== this.props.internalNotes.length
        const lastInternalNoteHasChanged = prevProps.internalNotes.length > 0 && this.props.internalNotes.length > 0 &&
            prevProps.internalNotes[0].attributes.notes !== this.props.internalNotes[0].attributes.notes
        const hasUpdated = lengthHasChanged || lastInternalNoteHasChanged

        if (hasUpdated) {
            this.setState({
                internalNotes: this.sortInternalNotes(this.props.internalNotes),
            })
        }
    }

    handleCloseModal() {
        this.setState({
            modal: ''
        })
    }

    handleRefreshEvent(event) {
        if (this.props.onRefresh) {
            this.props.onRefresh(event)
        }
    }

    openInternalNotesModal(noteId, notes) {
        return function (e) {
            e.preventDefault()
            this.setState({
                modal: <InternalNotesModal
                    noteId={noteId}
                    notes={notes}
                    projectId={this.props.projectObject.id}
                    onClose={this.handleCloseAndRefresh}
                    onSubmit={this.handleCloseAndRefresh}
                />
            })
        }.bind(this)
    }


    toggleShowAll(e) {
        e.preventDefault()
        this.setState({
            showAll: !this.state.showAll,
        })
    }

    renderInternalNote(internalNote) {
        return (
            <div className={'mb-2 blockquote bg-light py-3'}>
                {internalNote.attributes.notes.split('\n').map((v, i) =>
                    <p key={i}>{v}</p>)}
                <p className={'mb-2 text-secondary blockquote-footer'}>
                    <FormattedMessage
                        id="order.analytics.internal_notes.written_by_format"
                        defaultMessage="{updatedByUser} on {updatedDate} at {updatedTime}"
                        values={{
                            updatedByUser:
                                <UserNameLabel className={'strong'}
                                    value={internalNote.attributes.updatedBy}
                                />,
                            updatedDate:
                                <FormattedDate
                                    year='numeric'
                                    month='long'
                                    day='numeric'
                                    value={new Date(internalNote.attributes.updatedAt)}
                                />,
                            updatedTime:
                                <FormattedTime
                                    value={new Date(internalNote.attributes.updatedAt)}
                                />,
                        }}
                    />
                </p>
            </div>
        )
    }

    sortInternalNotes(array) {
        array.sort((internalNoteA, internalNoteB) => {
            if (internalNoteA.attributes.createdAt > internalNoteB.attributes.createdAt) {
                return -1;
            }
            if (internalNoteA.attributes.createdAt < internalNoteB.attributes.createdAt) {
                return 1;
            }
            return 0;
        })
        return array
    }


    render() {
        let lastInternalNote = null
        if (this.state.internalNotes.length > 0) {
            lastInternalNote = this.state.internalNotes[0]
        }

        return (
            <div className="col-12" >
                {this.state.modal}
                < div className={'w-100'} >
                    <label className="col-form-label custom-form-label pt-0">
                        <strong>
                            <FormattedMessage
                                id="order.analytics.internal_notes.last_internal_notes_label"
                                defaultMessage="Last internal notes"
                            />
                        </strong>
                    </label>
                </div >
                <div className={'w-100'}>
                    {!lastInternalNote &&
                        <div className={'w-100 text-secondary text-center py-2 strong mb-2'} style={{ border: '5px dashed #dee2e6' }}>
                            <em>
                                <FormattedMessage
                                    id="order.analytics.internal_notes.no_internal_note_yet"
                                    defaultMessage="No internal note has been written yet..."
                                />
                            </em>
                        </div>}

                    {!this.state.showAll && lastInternalNote &&
                        this.renderInternalNote(lastInternalNote)
                    }

                    {this.state.showAll &&
                        this.state.internalNotes.map(e => {
                            return this.renderInternalNote(e)
                        })
                    }

                    {!this.state.showAll && this.state.internalNotes.length > 1 &&
                        <div className={'w-100 text-center pt-1 mb-4'} >
                            <small>
                                <a href={'#'} onClick={this.toggleShowAll}>
                                    <Icon value={'arrows-alt-v'} />
                                    <FormattedMessage
                                        id="order.analytics.internal_notes.show_all_internal_notes"
                                        defaultMessage="Show {updatedCount} previous internal note(s)"
                                        values={{
                                            updatedCount: this.state.internalNotes.length - 1
                                        }}
                                    />
                                </a>
                            </small>
                        </div>
                    }

                    {this.state.showAll && this.state.internalNotes.length > 1 &&
                        <div className={'w-100 text-center pt-1 mb-4'} >
                            <small>
                                <a href={'#'} onClick={this.toggleShowAll}>
                                    <Icon value={'arrows-alt-v'} />
                                    <FormattedMessage
                                        id="order.analytics.internal_notes.hide_all_internal_notes"
                                        defaultMessage="Hide previous internal note(s)"
                                    />
                                </a>
                            </small>
                        </div>
                    }

                    <div className={'w-100'}>
                        <button className="btn btn-primary mr-2 mb-2" onClick={this.openInternalNotesModal(null, null)}>
                            <Icon value={"quote-right"} className={"mr-1"} />
                            <FormattedMessage
                                id="order.analytics.internal_notes.write_internal_note_btn"
                                defaultMessage="Write an internal note"
                            />
                        </button>

                        {lastInternalNote &&
                            <button className="btn btn-outline-primary mr-2 mb-2" onClick={this.openInternalNotesModal(lastInternalNote.id, lastInternalNote.attributes.notes)}>
                                <Icon value={"edit"} className={"mr-1"} />
                                <FormattedMessage
                                    id="order.analytics.internal_notes.edit_internal_note_btn"
                                    defaultMessage="Edit the last note"
                                />
                            </button>
                        }
                    </div>
                </div>
            </div >
        )
    }

}

export default injectIntl(InternalNotes)


// WEBPACK FOOTER //
// ./src/order/internalnotes.component.jsx